import { render, staticRenderFns } from "./CertificateResultModal.vue?vue&type=template&id=48dbf45e&scoped=true"
import script from "./CertificateResultModal.vue?vue&type=script&lang=js"
export * from "./CertificateResultModal.vue?vue&type=script&lang=js"
import style0 from "./CertificateResultModal.vue?vue&type=style&index=0&id=48dbf45e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dbf45e",
  null
  
)

export default component.exports